import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';

const API_LIST = '/offer-templates';
const API_DETAIL = (id: number) => `/offer-templates/${id}`;

export interface OfferTemplate {
  id: number;
  name: string;
  isDefault?: boolean;
  introText?: string | null;
  deliveryText?: string | null;
  paymentMethodText?: string | null;
  notes?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
}

export const useOfferTemplates = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<OfferTemplate[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    { revalidateOnFocus: true, revalidateOnReconnect: true }
  );
  return {
    data: data ?? [],
    isLoading,
    isError: !!error,
    mutate,
  };
};

export const useOfferTemplate = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<OfferTemplate>(
    id ? API_DETAIL(id) : null,
    fetcher,
    { revalidateOnFocus: true }
  );
  return {
    data,
    isLoading,
    isError: !!error,
    mutate,
  };
};
